/**
 * Redux Actions for RBAC Permissions
 */

/**
 * Set user permissions in Redux store
 * @param {Object} permissionsMap - Map of feature codes to operations
 */
export const SetUserPermissions = (permissionsMap) => ({
  type: "SET_USER_PERMISSIONS",
  payload: permissionsMap
});

/**
 * Clear user permissions from Redux store
 */
export const ClearUserPermissions = () => ({
  type: "CLEAR_USER_PERMISSIONS"
});

/**
 * Set permissions loading state
 * @param {boolean} loading - Loading state
 */
export const SetPermissionsLoading = (loading) => ({
  type: "SET_PERMISSIONS_LOADING",
  payload: loading
});

/**
 * Set permissions error
 * @param {string} error - Error message
 */
export const SetPermissionsError = (error) => ({
  type: "SET_PERMISSIONS_ERROR",
  payload: error
});
